import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.div`
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-image 1s ease-in-out;
  @media (max-width: 768px) {
    height: 40vh;
  }
`;

const HeroText = styled.div`
  color: #000;
  font-size: 48px;
  font-weight: bold;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const images = [
  "/images/white-zip-shirt-small.png",
  "/images/adire_shirt.png"
];

function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ backgroundColor: '#bcae9f' }}>
      <HeroSection bgImage={images[currentImageIndex]}>
        <HeroText>
          Explore Our Latest Collection
          <br />
          <button style={{ fontSize: 30, backgroundColor: 'black', color: "#fff" }}>
            SHOP NOW
          </button>
        </HeroText>
      </HeroSection>
    </div>
  );
}

export default Hero;
